import ObjectIdNodeIdsMappings from '../modelling/ObjectIdNodeIdsMappings';
import ParameterErrors from '../errors/ParameterErrors';
const { throwNotProvided, throwNotOfType } = ParameterErrors;
export default class Model {
    constructor(props) {
        const { groupCode, code, relativePath, objectIdNodeIdsMappings, quadrantsRelativePath} = props;
        if (!code) throwNotProvided("code");
        if (!groupCode) throwNotProvided("groupCode");
        if (!objectIdNodeIdsMappings) throwNotProvided("objectIdNodeIdsMappings");
        this._code = code;
		this._groupCode = groupCode;
		this._relativePath = relativePath;
		this._objectIdNodeIdsMappings = objectIdNodeIdsMappings;
		this._quadrantsRelativePath = quadrantsRelativePath;

    }
    get code() {
        return this._code;
    }
    get groupCode() {
        return this._groupCode;
    }
	get relativePath(){
		return this._relativePath;
	}
	get objectIdNodeIdsMappings(){
		return this._objectIdNodeIdsMappings;
	}
	get quadrantsRelativePath(){
		return this._quadrantsRelativePath;
	}
    static fromObj(obj) {
        return new Model({
			groupCode:obj.groupCode,
            code: obj.code,
			relativePath:obj.relativePath,
			quadrantsRelativePath:obj.quadrantsRelativePath,
			objectIdNodeIdsMappings:obj.objectIdNodeIdsMappings?ObjectIdNodeIdsMappings.fromJSON(obj.objectIdNodeIdsMappings):null
        })
    }
}
